import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./_style.scss";

const Placeholder = ({
  children,
  isInvalid,
  look,
  text,
  ...other
}) => (
  <div
    className={
      classNames(
        "placeholder",
        {
          [`--${look}`]: look,
          "--isInvalid": isInvalid,
        },
        other.className,
      )
    }
  >
    <div className="placeholder__icon">
      {children}
    </div>
    { text && <p className="placeholder__text">{text}</p> }
  </div>
);

Placeholder.propTypes = {
  children: PropTypes.node,
  text: PropTypes.node,
  look: PropTypes.string,
  isInvalid: PropTypes.bool,
};

export default Placeholder;
